<template>
    <div class="tab-body">
      <div class="search">
        <el-form ref="form" :model="searchParams" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="名称">
                <el-input v-model="searchParams.name"></el-input>
              </el-form-item>
            </el-col>
  
            <el-collapse-transition>
              <div v-if="isShowMoreSearch">
                <!--隐藏区域-->
              </div>
            </el-collapse-transition>
            <div class="search-btn">
              <el-button type="primary" icon="el-icon-search" @click="search"
                >搜索</el-button
              >
              <el-button @click="clearSearchVal">清空</el-button>
             
            </div>
          </el-row>
        </el-form>
      </div>
      <div class="operator">
        <el-button type="primary" icon="el-icon-plus" @click="toSave()"
          >添加</el-button
        >
        <el-button type="danger" icon="el-icon-delete" @click="batchRemove()"
          >批量删除</el-button
        >
      </div>
      <div class="dataTable autoFlex" v-if="listData">
        <el-table
          class="table"
          :data="listData.records"
          stripe
          height="auto"
          @selection-change="selectionChange"
          v-loading="listLoading"
          border
        >
          <el-table-column
            type="selection"
            width="55"
            fixed="left"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            width="200px"
          ></el-table-column>
          <el-table-column prop="url" label="图片" width="160px">
            {{baseUrl}}
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 50px"
                :src="baseUrl + scope.row.url+'?'+Math.random()"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            prop="url"
            label="地址"
          >
          <template slot-scope="scope">
            {{  scope.row.url }}
            </template>
        </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="160px"
          ></el-table-column>
          
          <el-table-column label="操作" fixed="right" width="240px">
            <template slot-scope="scope">
              <div class="dataTable-operator">
                <el-button
                  size="mini"
                  @click="toDetail(scope.$index, scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  @click="toUpdate(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="remove(scope.$index, scope.row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBar">
          <el-pagination
            @size-change="sizeChange"
            @current-change="currentChange"
            :total="listData.total"
            :page-size="page.size"
            :current-page="page.current"
            :layout="this.$constant.page.layout"
            :page-sizes="this.pageSizes"
          ></el-pagination>
        </div>
      </div>
      <edit ref="edit"></edit>
    </div>
  </template>
  <script>
  import edit from "./edit.vue";
  import api from "@/api/online/onlinephoto/onlinephoto.js";
  import constant from "@/util/constant.js";
  export default {
    name: "tOnlinePhoto",
    components: {
      edit,
    },
    data() {
      return {
        pageSizes: ["5", "10"],
        searchParams: {},
        isShowMoreSearch: false,
        listLoading: false,
        listData: [],
        selected: [],
        baseUrl: constant.serverUrl ,
        page: {
          size: 5,
          current: 1,
        },
      };
    },
    methods: {
      //获取数据
      list() {
        this.listLoading = true;
        let params = this.$utils.merger(this.searchParams, this.page);
        api.list(params, (response) => {
          this.listData = response.data;
          this.listLoading = false;
        });
      },
      //去添加
      toSave() {
        this.$refs.edit.open({}, "添加");
      },
      //去编辑
      toUpdate(index, row) {
        let editParameter = {
          id: row.id,
        };
        this.$refs.edit.open(editParameter, "编辑");
      },
      //去详情
      toDetail(index, row) {
        let detailParameter = {
          id: row.id,
        };
        this.$refs.edit.open(detailParameter, "详情", true);
      },
      //删除
      remove(index, row) {
        let parameter = {
          ids: row.id,
        };
        this.$utils.confirm.warning("提示", "确定删除吗？", () => {
          api.remove(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
            }
          );
        });
      },
      //批量删除
      batchRemove() {
        if (!this.selected || this.selected.length == 0) {
          this.$utils.msg.info("请选择至少一行");
          return;
        }
        let parameter = {
          ids: this.selected,
        };
        this.$utils.confirm.warning("提示", "确定删除吗？", () => {
          api.remove(
            {
              ids: this.selected,
            },
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
            }
          );
        });
      },
      //改变选择项
      selectionChange(val) {
        //清空
        this.selected = [];
        for (let item of val) {
          this.selected.push(item.id);
        }
      },
      //改变每页显示数量
      sizeChange(val) {
        this.page.size = val;
        this.list();
      },
      //改变现在的页码
      currentChange(val) {
        this.page.current = val;
        this.list();
      },
  
      //搜索
      search() {
        this.list();
      },
      //清空搜索框
      clearSearchVal() {
        this.searchParams = {};
        this.list();
      },
    },
    mounted() {
      this.list();
    },
  };
  </script>
  
  <style lang="scss" scoped="scoped">
  @import "~common/custom/css/common.scss";
  </style>
  
  